import React from "react";
import Icons from "../../../../config/images";
import "./heroSection.css";
import Header from "../../../../components/Header/header";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact-form');
  };


  return (
    <div className="hero-section-main-black-container">
      {/* Navbar */}
      <Header />

      {/* Hero Section */}
      <div className="hero">
        <div className="hero-section-hero-content">
          <div className="hero-section-bold-text-parent-container">
            <span className="hero-section-bold-text-style">
              Innovating the Future of IT Solutions
            </span>
          </div>
          <p className="hero-section-medium-text-style">
            Customized technology services to elevate your business.
          </p>
          <div className="hero-section-buttons-container">
            <button className="btn primary">
              <span className="btn-text" onClick={handleClick}>Contact Us</span>
            </button>
            <button className="btn primary">
              <span className="btn-text">Learn More</span>
            </button>
          </div>
        </div>

        <div className="hero-image-container">
          <img src={Icons.homeImage} alt="Office Work" className="hero-image" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
